// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const volcanion: PokeData = {
  "id": 721,
  "name": "volcanion",
  "height": 17,
  "weight": 1950,
  "base_experience": 270,
  "types": [
    PokeType.FIRE,
    PokeType.WATER
  ],
  "api_moves": [
    "stomp",
    "body-slam",
    "take-down",
    "leer",
    "mist",
    "water-gun",
    "hydro-pump",
    "fire-spin",
    "haze",
    "explosion",
    "scary-face",
    "weather-ball",
    "overheat",
    "water-pulse",
    "flare-blitz",
    "flame-charge",
    "scald",
    "incinerate",
    "steam-eruption"
  ],
  "moves": [
    "body-slam",
    "leer",
    "hydro-pump",
    "fire-spin",
    "scary-face",
    "flare-blitz",
    "bubble-beam",
    "ember",
    "life-dew",
    "eruption",
    "bubble",
    "whirlpool",
    "morning-sun"
  ],
  "evolution_chain": {
    "id": 373,
    "item": null,
    "species": [
      {
        "name": "volcanion",
        "order": 721,
        "types": [
          PokeType.FIRE,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 96,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
